const PRODUCTION_API_ORIGIN = 'https://api.fliplottery.com';
function validateOrigin(value, secure = false) {
  let url;
  try { if (typeof value !== 'string' || !value.trim()) throw new Error(); url = new URL(value.trim()); }
  catch (_) { throw new Error('An explicit valid API origin is required.'); }
  if (!['http:', 'https:'].includes(url.protocol) || (secure && url.protocol !== 'https:') ||
      url.username || url.password || url.pathname !== '/' || url.search || url.hash) {
    throw new Error('API origin must be an origin only, without credentials, paths, query or fragment; staging requires HTTPS.');
  }
  return url.origin;
}
function resolveApiOrigin({ nodeEnv, deploymentEnv, apiOrigin } = {}) {
  const mode = deploymentEnv || (nodeEnv === 'production' ? 'production' : 'development');
  if (!['production', 'staging', 'development'].includes(mode) || (nodeEnv === 'production' && mode === 'development')) throw new Error('Invalid deployment mode.');
  if (mode === 'staging') {
    const origin = validateOrigin(apiOrigin, true);
    if (['api.fliplottery.com', 'fliplottery.com', 'www.fliplottery.com', 'admin.fliplottery.com'].includes(new URL(origin).hostname.toLowerCase().replace(/\.+$/, ''))) throw new Error('Production API is forbidden in staging.');
    return origin;
  }
  if (mode === 'production') {
    if (apiOrigin && validateOrigin(apiOrigin, true) !== PRODUCTION_API_ORIGIN) throw new Error('Production API override requires separate review.');
    return PRODUCTION_API_ORIGIN;
  }
  return apiOrigin ? validateOrigin(apiOrigin) : 'http://localhost:9500';
}
module.exports = { resolveApiOrigin };
